var map = {
	"./_base-breadcrumbs.vue": 7959,
	"./_base-button-genre.vue": 7135,
	"./_base-button-play.vue": 8082,
	"./_base-button.vue": 2870,
	"./_base-card-link.vue": 1675,
	"./_base-card.vue": 7967,
	"./_base-content.vue": 9439,
	"./_base-custom-select.vue": 6547,
	"./_base-dropdown.vue": 1911,
	"./_base-empty-list.vue": 962,
	"./_base-favourites.vue": 5336,
	"./_base-hero-background.vue": 8360,
	"./_base-hero.vue": 2879,
	"./_base-icon.vue": 8569,
	"./_base-input.vue": 7763,
	"./_base-link.vue": 4446,
	"./_base-load-more.vue": 3441,
	"./_base-placeholder.vue": 9416,
	"./_base-resource-cover.vue": 2375,
	"./_base-resource-image.vue": 931,
	"./_base-search-input.vue": 4162,
	"./_base-section.vue": 1152,
	"./_base-select.vue": 7938,
	"./_base-spinner.vue": 9725,
	"./_base-tab-panel.vue": 5529
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4716;